module.exports = __webpack_public_path__ + "static/media/netlify-icon.95e178f5.png";